import { Col, Row, Typography } from 'antd';
import React from 'react';
import { Divider } from '@common/components';
import { toUSCompactDateFormat } from 'works/legacy/lib/date-helper';
import { InvoiceReviewFragmentType } from '@pay-bill/graphql';

const { Text } = Typography;

export const BillingSummaryDetails = ({
  invoice,
  isSupplier,
}: {
  invoice: InvoiceReviewFragmentType;
  isSupplier: boolean;
}) => {
  return (
    <div className="billing-summary-details">
      <Row className="row-details">
        <Col span={4}>
          <Text type="secondary">Created</Text>
        </Col>
        <Col span={20}>{toUSCompactDateFormat(invoice.createdAt)}</Col>
      </Row>
      <Row className="row-details">
        <Col span={4}>
          <Text type="secondary">Due</Text>
        </Col>
        <Col span={20}>{toUSCompactDateFormat(invoice.due)}</Col>
      </Row>
      <Divider gutter />
      <Row className="row-details">
        <Col span={4}>
          <Text type="secondary">{isSupplier ? 'From:' : 'Remit To:'}</Text>
        </Col>
        <Col span={20}>
          {invoice.defaultRemitToBillingAddress.map(
            (text: string, index: number) => (
              <Row className="details-line sentry-mask" key={index}>
                <Text strong={index === 0}>{text}</Text>
              </Row>
            )
          )}
        </Col>
      </Row>
      <Row className="row-details">
        <Col span={4}>
          <Text type="secondary">Billed To:</Text>
        </Col>
        <Col span={20}>
          <Row className="details-line">
            <Text strong>{invoice.organization.name}</Text>
          </Row>
          {invoice.defaultToBillingAddress.map(
            (text: string, index: number) => (
              <Row className="details-line" key={index}>
                <Text>{text}</Text>
              </Row>
            )
          )}
        </Col>
      </Row>
      <style jsx>{`
        .billing-summary-details :global(.row-details) {
          margin-bottom: 12px;
        }
        .billing-summary-details :global(.details-line) {
          margin-bottom: 4px;
        }
      `}</style>
    </div>
  );
};
